import React, { useEffect, useRef, useState } from "react";
import "../style.css";
import { ArrowRepeat, PlusCircle } from "react-bootstrap-icons";
import { v4 as uuidv4 } from "uuid";
const uuid = uuidv4();
// Helper for uploading the image to the server
async function uploadImageToServer(imageFile, session) {
  const formData = new FormData();
  formData.append("image", imageFile);
  // No caption for single-image upload; add if needed

  const response = await fetch(
    `https://api.edit.guru-x.de/save_image/${session}`,
    {
      method: "POST",
      body: formData,
    }
  );
  if (!response.ok) {
    throw new Error("Image upload failed");
  }
  const data = await response.json();
  // Extract filename from the server's returned component string
  const match = data.image_code.match(/imageUrl="([^"]+)"/);
  if (match) {
    return match[1];
  } else {
    throw new Error("Server did not return an image filename");
  }
}

function ImageGenerator({ openModal, session }) {
  const [imageFile, setImageFile] = useState(null);
  const [imageSrc, setImageSrc] = useState(""); // now only the filename
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [result, setResult] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [sizePercent, setSizePercent] = useState(100);
  const [caption, setCaption] = useState("");

  // This handles file selection and immediate upload
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    setImageSrc("");
    setImageFile(null);
    if (!file) return;
    setUploading(true);
    try {
      const filename = await uploadImageToServer(file, session);
      setImageFile(file); // optionally save, but not used for display
      setImageSrc(filename); // just the filename
    } catch (err) {
      alert("Image upload failed: " + err.message);
    }
    setUploading(false);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const generateComponentCode = () => {
    // Only the filename now in imageSrc
    const ImageComponent =
      `<div id="${uuid}" />` +
      `<Image imageUrl="${imageSrc}" sizePercent="${sizePercent}%" caption="${caption}"/>`;
    setResult(ImageComponent);
    openModal && openModal(ImageComponent);
    console.log(ImageComponent);
  };

  const imageRef = useRef(null);

  // Reset function
  const fileInputRef = useRef(null);
  const resetAll = () => {
    setImageFile(null);
    setImageSrc("");
    setCaption("");
    setResult(null);
    // Actually clears the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  return (
    <div className="grid place-items-center m-8 p-8 items-center">
      <div className="flex flex-col w-full h-full items-center">
        <div className="my-4 items-center text-center">
          <div className=" text-sm m-2">Supported formats: JPEG and PNG</div>
          <input
            id="imageInput"
            ref={fileInputRef}
            type="file"
            className="file-input file-input-bordered file-input-primary w-full max-w-xs"
            accept="image/jpeg,image/png"
            onChange={handleImageUpload}
            disabled={uploading}
          />

          <div className="my-5 flex items-center justify-center">
            <label htmlFor="range" className="mr-3">
              Size
            </label>
            <input
              id="range"
              type="range"
              min={0}
              max="100"
              value={sizePercent}
              onChange={(e) => setSizePercent(Number(e.target.value))}
              className="range range-primary range-sm mx-4 w-44"
            />
          </div>
          <div className="h-5"></div>
          {imageSrc && (
            <div
              className="relative mx-auto  w-fit  "
              style={{
                width: `${sizePercent}%`,
                //maxWidth: imageRef.current?.getBoundingClientRect().width,
              }}
            >
              <img
                ref={imageRef}
                src={`https://api.edit.guru-x.de/preview/${session}/${imageSrc}`}
                alt="Uploaded"
                className="block max-w-full "
              />
            </div>
          )}
        </div>
        <div className="h-5"></div>
        <textarea
          className="text-sm shadow appearance-none border rounded w-10/12 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          placeholder="Enter a caption..."
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          disabled={uploading}
        ></textarea>
        <div className="flex flex-row m-auto pt-10">
          {" "}
          <button
            className="btn btn-square min-w-40 mx-4"
            onClick={generateComponentCode}
            disabled={!imageSrc}
          >
            Create
          </button>
          <button
            id="resetButton"
            key="resetButton"
            type="reset"
            onClick={resetAll}
            className="btn btn-circle m-auto"
          >
            <ArrowRepeat size={30} />
          </button>{" "}
        </div>
        {/**    {result && (
          <div className="mt-5 font-mono whitespace-pre">{result}</div>
        )}*/}
      </div>
    </div>
  );
}

export default ImageGenerator;
